import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { ApiGetAllRoles } from "../../../api/roles";
import {
  ApiCreateUser,
  ApiEditUser,
  ApiGenerarUser,
} from "../../../api/usuarios";
import { ApiGetAllCargos } from "../../../api/cargos";
import ModalDefault from "../../modalDefault";
import {
  ApiGetAllTiposUsuarioXRango,
  ApiObtenerRangosSistema,
} from "../../../api/usuariosTipos";
import Select from "react-select";
import moment from "moment";
import SaefmanExcelUploadModal from "../saefman/SaefmanExcelUploadModal";

const CrearUsuario = ({
  updateListFn,
  state,
  setState,
  type,
  setType,
  resetState,
  showModalSave,
  setShowModalSave,
}) => {
  const [loading, setlLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [dataPassword, setDataPassword] = useState({});

  const [showModalGenerar, setShowModalGenerar] = useState(false);
  const [loadingGen, setlLoadingGen] = useState(false);
  const [showSaefmanModal, setShowSaefmanModal] = useState(false);

  const [tipos_Usuarios, setTipos_Usuarios] = useState([]);

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    const { data: Roles } = await ApiGetAllRoles();
    const rolesActivos = Roles.filter((data) => data.estado === true);
    setRoles(rolesActivos);

    const { data: Cargos } = await ApiGetAllCargos();
    const cargosActivos = Cargos.filter((data) => data.estado === true);

    const cargosSelect = cargosActivos.map((data) => ({
      ...data,
      value: data.pre_cargo_id,
      label: `${data.pre_cod_cargo} - ${data.pre_cargo}`,
    }));

    setCargos(cargosSelect);

    const { data: Rangos } = await ApiObtenerRangosSistema();
    setRangos(Rangos);

    const { data } = await ApiGetAllTiposUsuarioXRango();
    setTipos_Usuarios(data);
  };

  const onClosedModal = () => {
    setShowModal(false);
    setDataPassword({});
  };

  const [roles, setRoles] = useState([]);
  const [cargos, setCargos] = useState([]);
  const [rangos, setRangos] = useState([]);

  const onchange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);

    const newState = {
      ...state,
      [name]: value,
    };

    setState(newState);
  };
  const CrearFn = async () => {
    setlLoading(true);
    if (state.usuario === "") {
      toast.error("El nombre Usuario se encuentra vacío", {
        position: "bottom-center",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
      setlLoading(false);
      return;
    }

    if (state.correo === "") {
      toast.error("El correo se encuentra vacío", {
        position: "bottom-center",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
      setlLoading(false);
      return;
    }

    if (state?.pre_tipo_usuario_id === "") {
      toast.error("El campo Tipo de usuario es obligatorio", {
        position: "bottom-center",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
      setlLoading(false);
      return;
    }

    if (state.pre_rol_id === "") {
      toast.error("El campo Rol es obligatorio", {
        position: "bottom-center",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
      setlLoading(false);
      return;
    }

    if (state.nombres.trim() === "") {
      toast.error("El campo Nombre es obligatorio", {
        position: "bottom-center",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
      setlLoading(false);
      return;
    }

    if (state.apellidos.trim() === "") {
      toast.error("El campo Apellidos es obligatorio", {
        position: "bottom-center",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
      setlLoading(false);
      return;
    }

    const rol = roles.find(
      (data) => data.pre_rol_id === parseInt(state.pre_rol_id)
    );

    if (rol?.code === "3") {
      if (state.code === "") {
        toast.error("El campo codigo es obligatorio", {
          position: "bottom-center",
          style: {
            border: "1px solid red",
            padding: "16px",
            color: "white",
            background: "red",
            borderColor: "white",
          },
          iconTheme: {
            primary: "red",
            secondary: "white",
          },
        });
        setlLoading(false);
        return;
      }
    }

    const fechaMoment = moment(state.fecha_naci, "YYYY-MM-DD");
    const fecha_nacimiento = fechaMoment.isValid()
      ? fechaMoment.format("DD/MM/YYYY")
      : null;

    state.fecha_naci = fecha_nacimiento;

    const res =
      type === "save" ? await ApiCreateUser(state) : await ApiEditUser(state);
    const datares = res;
    if (datares.sms === "ok") {
      if (type === "save") {
        setShowModal(true);
        setDataPassword(datares.data[0]);
      }

      toast.success(datares.mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid green",
          padding: "16px",
          color: "white",
          background: "green",
          borderColor: "white",
        },
        iconTheme: {
          primary: "green",
          secondary: "white",
        },
      });
      setShowModalSave(false);
      setType("save");
      resetState();
      updateListFn();
    } else {
      toast.error(datares.mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
    }
    setlLoading(false);
  };

  const onCloseModal = () => {
    setShowModalSave(false);
    if (type !== "save") {
      setType("save");
      resetState();
    }
  };

  const handleGenerarUsuarios = async (e) => {
    setlLoadingGen(true);
    e.preventDefault();
    if (state.tipo === "") {
      toast.error("El campo Tipo de usuario es obligatorio", {
        position: "bottom-center",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
      setlLoadingGen(false);
      return;
    }

    if (state.cantidad === "") {
      toast.error("El campo Cantidad de usuarios es obligatorio", {
        position: "bottom-center",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
      setlLoadingGen(false);
      return;
    }

    const rango = rangos.find(
      (data) => data.pre_tipo_usuario_id === parseInt(state.tipo)
    );

    const res = await ApiGenerarUser({
      pre_tipo_usuario_id: state.tipo,
      tipo: rango.code,
      name: rango.tipo,
      cantidad: state.cantidad,
    });

    if (res.sms === "ok") {
      toast.success(res.mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid green",
          padding: "16px",
          color: "white",
          background: "green",
          borderColor: "white",
        },
        iconTheme: {
          primary: "green",
          secondary: "white",
        },
      });
      setState((prev) => ({ ...prev, tipo: "", cantidad: "" }));

      setShowModalGenerar(false);
      updateListFn();
    } else {
      toast.error(res.mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
    }
    setlLoadingGen(false);
  };

  return (
    <div>
      <div className="row mt-3 mb-4">
        <div className="col-md-6 col-lg-4  w-100">
          <div
            className=" bg-white  bordecompleto borde-tarjeta"
            style={{ height: "auto" }}
          >
            <div className="card-body m-0 p-0">
              <div className="w-100 bgfondo2 bordeabajo bordesombreado d-flex flex-column align-items-center d-flex justify-content-center py-3 px-3">
                <div className="w-100  d-flex justify-content-between align-items-center px-3">
                  <h5 className=" negrita card-title">
                    {type === "save" ? "Crear" : "Editar"} Usuario
                  </h5>
                  <div className="d-flex justify-content-between flex-row align-self-start gap-2">
                    <div className="d-flex justify-content-end ">
                      <button
                        type=""
                        className="bg-btn-vet bordesombreado"
                        onClick={() => {
                          setShowModalSave(true);
                        }}
                      >
                        <i className="fa fa-plus mx-2"></i>
                        Crear usuario
                      </button>
                    </div>
                    <div className="d-flex justify-content-end ">
                      <button
                        type=""
                        className="bg-btn-vet bordesombreado"
                        onClick={() => {
                          setShowModalGenerar(true);
                        }}
                      >
                        <i className="fa fa-users mx-2"></i>
                        Generar usuarios
                      </button>
                    </div>
                    <div className="d-flex justify-content-end ">
                      <button
                        type=""
                        className="bg-btn-vet bordesombreado"
                        onClick={() => setShowSaefmanModal(true)}
                      >
                        <i className="fa fa-file-excel mx-2"></i>
                        Carga masiva Excel (Saefman)
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <SaefmanExcelUploadModal
                isOpen={showSaefmanModal}
                onClose={() => setShowSaefmanModal(false)}
                onSuccess={updateListFn}
              />
              <ModalDefault
                bandera={"Crear usuario"}
                modal={showModalSave}
                size={"lg"}
                titulo={`Crear usuario`}
                closeAction={onCloseModal}
              >
                <div className="row py-4 ">
                  <div className="col-md-4">
                    <label className="py-2 negrita">Cedula</label>
                    <input
                      type="text"
                      id="usuario"
                      name="usuario"
                      value={state.usuario}
                      className="inputtext2 bordecompleto"
                      placeholder="Digite cedula"
                      onChange={onchange}
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="py-2 negrita">Codigo</label>
                    <input
                      type="text"
                      id="code"
                      name="code"
                      value={state.code}
                      className="inputtext2 bordecompleto"
                      placeholder="Digite el codigo"
                      onChange={onchange}
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="py-2 negrita">Correo</label>
                    <input
                      type="text"
                      id="correo"
                      name="correo"
                      value={state.correo}
                      className="inputtext2 bordecompleto"
                      placeholder="Digite el Correo"
                      onChange={onchange}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="py-2 negrita">Fecha de Nacimiento</label>
                    <input
                      type="date"
                      id="fecha_naci"
                      name="fecha_naci"
                      value={state.fecha_naci}
                      className="inputtext2 bordecompleto"
                      placeholder="Digite la Fecha de Nacimiento"
                      onChange={onchange}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="py-2 negrita">Tipo</label>
                    {/* <input
                      type="text"
                      id="tipo"
                      name="tipo"
                      value={state.tipo}
                      className="inputtext2 bordecompleto"
                      placeholder="Digite el Tipo"
                      onChange={onchange}
                    /> */}
                    <select
                      className="inputselect2 bordecompleto"
                      id="pre_tipo_usuario_id"
                      name="pre_tipo_usuario_id"
                      style={{ width: "100%" }}
                      onChange={onchange}
                      value={state.pre_tipo_usuario_id}
                    >
                      <option value="">Seleccione un Tipo...</option>
                      {tipos_Usuarios.length > 0
                        ? tipos_Usuarios.map((data, index) => (
                            <option
                              value={data.pre_tipo_usuario_id}
                              key={index}
                            >
                              {data.tipo}
                            </option>
                          ))
                        : null}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="py-2 negrita">Nombre</label>
                    <input
                      type="text"
                      id="nombres"
                      name="nombres"
                      value={state.nombres}
                      className="inputtext2 bordecompleto"
                      placeholder="Digite el Nombre"
                      onChange={(e) => onchange({ target: { name: "nombres", value: e.target.value.toUpperCase() } })}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="py-2 negrita">Apellidos</label>
                    <input
                      type="text"
                      id="apellidos"
                      name="apellidos"
                      value={state.apellidos}
                      className="inputtext2 bordecompleto"
                      placeholder="Digite los Apellidos"
                      onChange={(e) => onchange({ target: { name: "apellidos", value: e.target.value.toUpperCase() } })}
                    />
                  </div>
                  <div className="col-md-6 ">
                    <div className=" row">
                      <label className="x-0 py-2 negrita">Rol</label>

                      <div className={"col-md-12 p-0 m-0"}>
                        <select
                          className="inputselect2 bordecompleto"
                          id="pre_rol_id"
                          name="pre_rol_id"
                          style={{ width: "100%" }}
                          onChange={onchange}
                          value={state.pre_rol_id}
                        >
                          <option value="">Seleccione un Rol...</option>
                          {roles.length > 0
                            ? roles.map((data, index) => (
                                <option value={data.pre_rol_id} key={index}>
                                  {data.rol}
                                </option>
                              ))
                            : null}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 ">
                    <div className=" row">
                      <label className="x-0 py-2 negrita">Cargo</label>

                      <div className={"col-md-12 p-0 m-0"}>
                        <Select
                          id="pre_cargo_id"
                          name="pre_cargo_id"
                          value={cargos.find(
                            (data) => data.value === state.pre_cargo_id
                          )}
                          options={cargos}
                          styles={{
                            control: (base) => ({
                              ...base,
                              height: "45px",
                            }),
                          }}
                          onChange={(e) =>
                            onchange({
                              target: {
                                name: "pre_cargo_id",
                                value: e.value,
                              },
                            })
                          }
                          defaultValue={{
                            value: "",
                            label: "Seleccione un Cargo",
                          }}
                        />

                        {/*  <select
                          className="inputselect2 bordecompleto"
                          id="pre_cargo_id"
                          name="pre_cargo_id"
                          style={{ width: "100%" }}
                          onChange={onchange}
                          value={state.pre_cargo_id}
                        >
                          <option value="">Seleccione un Cargo...</option>
                          {cargos.length > 0
                            ? cargos.map((data, index) => (
                                <option value={data.pre_cargo_id} key={index}>
                                  {`${data.pre_cod_cargo} - ${data.pre_cargo}`}
                                </option>
                              ))
                            : null}
                        </select> */}
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end flex-row align-self-start pt-4 px-4">
                    <div className="d-flex justify-content-end ">
                      {loading ? (
                        <div className="spinner-border" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        <button
                          type=""
                          className="bg-btn-vet bordesombreado"
                          onClick={() => CrearFn()}
                        >
                          <i className="fas fa-save mx-2"></i>
                          {type === "save" ? "Guardar" : "Editar"} Usuario
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </ModalDefault>
              <ModalDefault
                bandera={"Generar usuarios"}
                modal={showModalGenerar}
                size={"md"}
                titulo={`Generar usuarios`}
                closeAction={() => setShowModalGenerar(false)}
              >
                <div className="row py-4 justify-content-center text-align-center ">
                  <div className="col-md-12">
                    <label className="py-2 negrita">Tipo de usuario</label>
                    <select
                      className="inputselect2 bordecompleto"
                      id="tipo"
                      name="tipo"
                      value={state.tipo}
                      onChange={onchange}
                    >
                      <option value="">Seleccione un tipo de usuario...</option>
                      {rangos.length > 0
                        ? rangos.map((data, index) => (
                            <option
                              value={data.pre_tipo_usuario_id}
                              key={index}
                            >
                              {data.tipo}
                            </option>
                          ))
                        : null}
                    </select>
                  </div>
                  <div className="col-md-12">
                    <label className="py-2 negrita">Cantidad de usuarios</label>
                    <input
                      type="number"
                      id="cantidad"
                      name="cantidad"
                      min={1}
                      value={state.cantidad}
                      className="inputtext2 bordecompleto"
                      placeholder="Digite la cantidad de usuarios a generar"
                      onChange={onchange}
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-end flex-row align-self-start my-4 gap-3">
                  <button
                    type=""
                    className="bg-btn-vet bordesombreado"
                    onClick={() => {
                      setShowModalGenerar(false);
                    }}
                  >
                    Cancelar
                  </button>
                  <button
                    type=""
                    className="bg-btn-vet bordesombreado"
                    onClick={handleGenerarUsuarios}
                    disabled={loadingGen}
                  >
                    Generar
                  </button>
                </div>
              </ModalDefault>
            </div>
          </div>
        </div>
      </div>
      <ModalDefault
        bandera={"confirmacion"}
        modal={showModal}
        size={"md"}
        icontitulo={<null />}
        titulo={dataPassword.mensaje}
        closeAction={onClosedModal}
      >
        <div className="row py-4 justify-content-center text-align-center ">
          {dataPassword.contrasena}
        </div>
        <div className="d-flex justify-content-end flex-row align-self-start my-4">
          <button
            type=""
            onClick={onClosedModal}
            className="bg-btn-vet-danger sombra mx-1"
          >
            Cancelar
          </button>
        </div>
      </ModalDefault>
    </div>
  );
};

export default CrearUsuario;
